import { render, staticRenderFns } from "./OnlinePay.vue?vue&type=template&id=ce31c404&scoped=true&"
import script from "./OnlinePay.vue?vue&type=script&lang=js&"
export * from "./OnlinePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce31c404",
  null
  
)

export default component.exports